import { MenuItem, FormControl, Select, Tooltip, Typography } from '@mui/material';
import { Info } from '@mui/icons-material';
import { useClinicContext } from '../ClinicContext';

function ClinicSelector({ onClinicChange }) {
  const {
    selectedClinicId,
    setSelectedClinicId,
    clinics = [],
    selectedClinic,
  } = useClinicContext();

  const isSelectable = Boolean(onClinicChange);
  const hasMultipleClinics = clinics.length > 1;

  function handleClinicChange(e) {
    const { value } = e.target;
    setSelectedClinicId(value);
    onClinicChange?.(value);
  }

  if (hasMultipleClinics && isSelectable) {
    return (
      <div className="flex items-center">
        <FormControl size="small">
          <Select
            value={selectedClinicId || ''}
            onChange={handleClinicChange}
            className="min-w-[320px] font-600 text-14 text-dark bg-white rounded-lg border-0 outline-0"
            sx={selectReset}
          >
            {clinics.map((clinic) => (
              <MenuItem value={clinic.id} key={clinic.id}>
                <span className="mr-6">{clinic.name}</span>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Tooltip title="Switch between your clinics from this drop-down list" placement="right">
          <Info className="text-white ml-10" />
        </Tooltip>
      </div>
    );
  }

  return (
    <div className="flex items-center">
      <Typography className="min-w-[320px] font-600 text-20 text-white">
        {selectedClinic?.name}
      </Typography>
    </div>
  );
}

const selectReset = {
  boxShadow: 'none',
  '.MuiOutlinedInput-notchedOutline': { borderWidth: 0 },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderWidth: 0 },
};

export default ClinicSelector;
